import styled from 'styled-components';
import { ImportUsers } from './ImportUsers.jsx';
import { AddUsers } from './AddUsers.jsx';
import { TopBar } from '../shared/TopBar.jsx';

const StyledDiv = styled.div`
  display: flex;
  padding: 0 24px;
`;

export const ManageUsers = () => {
  return (
    <>
      <TopBar />
      <StyledDiv>
        <ImportUsers />
        <AddUsers />
      </StyledDiv>
    </>
  );
};
